import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'José Ramírez',
    age: 44,
    location: 'Lima, Perú',
    quote: 'Mis alumnos participan mucho más desde que uso estas actividades.',
    initial: 'J',
    color: 'bg-blue-600'
  }, {
    name: 'Ana González',
    age: 39,
    location: 'Monterrey, México',
    quote: 'Me ayudó a organizar todo el semestre.',
    initial: 'A',
    color: 'bg-pink-600'
  }, {
    name: 'Felipe Torres',
    age: 36,
    location: 'Santiago, Chile',
    quote: 'Las clases ahora son mucho más dinámicas.',
    initial: 'F',
    color: 'bg-green-600'
  }, {
    name: 'Camila Rojas',
    age: 34,
    location: 'Medellín, Colombia',
    quote: 'Las evaluaciones físicas me ahorraron muchísimo tiempo.',
    initial: 'C',
    color: 'bg-purple-600'
  }, {
    name: 'Ricardo Silva',
    age: 42,
    location: 'Buenos Aires, Argentina',
    quote: 'Los juegos cooperativos funcionan perfecto con grupos grandes.',
    initial: 'R',
    color: 'bg-orange-600'
  }, {
    name: 'Paula Fernández',
    age: 37,
    location: 'Quito, Ecuador',
    quote: 'Es exactamente el tipo de material que necesitaba.',
    initial: 'P',
    color: 'bg-teal-600'
  }];
  return <section className="py-20 bg-[#143524]" data-id="element-453">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-454">
        <div className="text-center mb-16" data-id="element-455">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-456">
            Lo que dicen los docentes que ya usan este sistema:
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-457">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#0C2818] p-6 rounded-2xl border border-[#1E4D2B] flex flex-col" data-id="element-458">
              <div className="flex items-center gap-4 mb-4" data-id="element-459">
                <div className={`w-12 h-12 rounded-full ${t.color} flex items-center justify-center text-white font-bold text-xl shadow-md`} data-id="element-460">
                  {t.initial}
                </div>
                <div data-id="element-461">
                  <h4 className="font-bold text-white" data-id="element-462">{t.name}</h4>
                  <p className="text-xs text-gray-400" data-id="element-463">
                    {t.age} años, {t.location}
                  </p>
                </div>
              </div>

              <div className="flex-1" data-id="element-464">
                <div className="flex gap-1 text-[#FBBF24] mb-3" data-id="element-465">
                  {[...Array(5)].map((_, starI) => <Star key={starI} className="w-4 h-4 fill-current" data-id="element-466" />)}
                </div>
                <p className="text-gray-300 italic leading-relaxed" data-id="element-467">
                  "{t.quote}"
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}